import React from 'react';
import GlobalizationSelector from '@homeaway/react-globalization-selector';
import URLSearchParams from 'url-search-params';
import get from 'lodash.get';
import ConnectorContext from '../components/context/ConnectorContext';

export default class GlobalizationSelectorConnector extends React.Component {
    static contextType = ConnectorContext;

    getRedirectUrl = (locale, siteUrl, currency) => {
        let countryCode = locale.split('_')[1].toLowerCase();
        let origin;
        let params;

        if (countryCode === this.props.countryCode) {
            origin = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
            params = new URLSearchParams(window.location.search);
        } else {
            origin = siteUrl.replace(/\/$/, '');
            params = new URLSearchParams();
        }

        if (this.props.languageCode !== locale) {
            params.set('gx-locale', locale);
        }
        if (this.props.currencyCode !== currency) {
            params.set('cur', currency);
        }

        return `${origin}${params.toString() !== '' ? `?${params.toString()}` : ''}`;
    };

    handleChangeGlobalSelector = async (locale, siteUrl, currencyCode) => {
        if (window && window.location) {
            const redirectUrl = this.getRedirectUrl(locale, siteUrl, currencyCode);
            const saveCurrencyVariant = get(window, '__ABACUS__.VRBO_SAVE_CURRENCY.value');
            const {dataUrl} = this.context;

            if (saveCurrencyVariant) {
                if (this.props.currencyCode !== currencyCode) {
                    await fetch(`${dataUrl}saveCurrency`, {
                        method: 'PATCH',
                        credentials: 'same-origin',
                        body: JSON.stringify({'currency': currencyCode}),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then((response) => response.json())
                        .catch((error) => console.info(error));
                }
            }

            if (this.props.onGlobalSelectorChange) {
                this.props.onGlobalSelectorChange({
                    redirectUrl,
                    locale,
                    currency: currencyCode,
                    siteUrl
                });
            } else {
                window.location.assign(redirectUrl);
            }
        }
    };

    render() {
        return <GlobalizationSelector {...this.props} onGlobalSelectorChange={this.handleChangeGlobalSelector} />;
    }
}
